'use client'

import { Search, Command } from 'lucide-react'

// BIRHAUS: Utility function (replaces @/lib/utils cn)
function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ')
}

interface SearchAndCommandPaletteProps {
  showSearch: boolean
  onSearchClick?: () => void
  searchLabel: string
  searchPlaceholder: string
  showCommandPalette: boolean
  onCommandPaletteToggle?: () => void
  commandPaletteLabel: string
  commandPaletteShortcut: string
  bp: string
}

export function SearchAndCommandPalette({
  showSearch,
  onSearchClick,
  searchLabel,
  searchPlaceholder,
  showCommandPalette,
  onCommandPaletteToggle,
  commandPaletteLabel,
  commandPaletteShortcut,
  bp
}: SearchAndCommandPaletteProps) {
  return (
    <>
      {/* Search */}
      {showSearch && (
        <button
          onClick={onSearchClick}
          className="p-2 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded"
          aria-label={searchLabel}
          title={searchPlaceholder}
        >
          <Search className="h-5 w-5" />
        </button>
      )}
      
      {/* Command Palette */}
      {showCommandPalette && (
        <button
          onClick={onCommandPaletteToggle}
          className={cn(
            'hidden', `${bp}:flex`,
            'items-center space-x-2 px-3 py-1 text-sm text-gray-600 bg-gray-50 hover:bg-gray-100 rounded-md transition-colors',
            'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
          )}
          aria-label={commandPaletteLabel}
        >
          <Command className="h-4 w-4" />
          <span className="text-xs">{commandPaletteShortcut}</span>
        </button>
      )}
    </>
  )
}
